import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const fallbackFirebaseConfig = {
  apiKey: "AIzaSyBOQl9lXCGa4hMrYVXeYyGVGrSeLSlxgMU",
  authDomain: "pmt-bd-subt-598r2eb.firebaseapp.com",
  projectId: "pmt-bd-subt-598r2eb",
  storageBucket: "pmt-bd-subt-598r2eb.firebasestorage.app",
  messagingSenderId: "389257670902",
  appId: "1:389257670902:web:978585452a3109803e7cd7",
};

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || fallbackFirebaseConfig.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || fallbackFirebaseConfig.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || fallbackFirebaseConfig.projectId,
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || fallbackFirebaseConfig.storageBucket,
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || fallbackFirebaseConfig.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || fallbackFirebaseConfig.appId,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Persistence set to browserSessionPersistence");
  })
  .catch((error) => {
    console.error("Error setting persistence:", error.code, error.message);
  });

const googleProvider = new GoogleAuthProvider();
const firestore = getFirestore(app);

export { auth, googleProvider, firestore };
